import styles from '../Calculator.module.css';

interface Props {
  value: boolean;
  onChange: (v: boolean) => void;
  labelYes?: string;
  labelNo?: string;
  'aria-label'?: string;
}

export function YesNoToggle({ value, onChange, labelYes = 'Ja', labelNo = 'Nein', 'aria-label': ariaLabel }: Props) {
  return (
    <div className={styles.yesNoToggle} role="group" aria-label={ariaLabel}>
      <div className={styles.yesNoToggleInnerContainer}>
        <button
          type="button"
          className={[styles.yesNoOption, value ? styles.yesNoOptionActive : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(true)}
          aria-pressed={value}
        >
          {labelYes}
        </button>
        <button
          type="button"
          className={[styles.yesNoOption, !value ? styles.yesNoOptionActive : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(false)}
          aria-pressed={!value}
        >
          {labelNo}
        </button>
      </div>
    </div>
  );
}
